
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import PostSingleViolation from '@/components/Post/PostSingleViolation.vue'
import AError from '@/components/Post/SinglePost/AError.vue'
import { PostsRoot } from '@/composables/post/postList'
import PostSingleParent from '@/components/Profile/PostSingleParent.vue'
import { useRouter } from '@/routing/router'
import PostEditButton from '@/components/Post/SinglePost/PostEditButton.vue'
import useConfiguration from '@/composables/configuration/configuration'

export default defineComponent({
  name: 'PostContent',
  emits: ['toggle-edit-form'],
  components: {
    PostEditButton,
    PostSingleParent,
    AError,
    PostSingleViolation,
    AButton,
  },
  props: {
    stripLongText: {
      type: Boolean,
      default: false,
    },
    showContentAuthor: {
      type: String,
      default: '',
    },
    stripLongTextSuffix: {
      type: String,
      default: ' ',
    },
    stripLongTextButton: {
      type: Boolean,
      default: true,
    },
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    stripLongTextLength: {
      type: Number,
      default: 235,
    },
    showParentAuthorRef: {
      type: Boolean,
      default: false,
    },
    showParentAnnotation: {
      type: Boolean,
      default: false,
    },
    allowShowNew: {
      type: Boolean,
      default: false,
    },
    postEditing: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    expandTruncate(text: any, target: any) {
      if (target === undefined) {
        return false
      }

      target.innerHTML = text
      target.classList.add('is-expanded')
    },
    truncate(text: any, length: number, suffix: any) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    },
  },
  setup() {
    return {
      ...useRouter(),
      ...useConfiguration(),
    }
  },
})
